import { hasFeatureAccess } from '../utils/authUtils'

// Multi-language survey scripting POC. Limited to focaldata staff in every
// environment, via hasFeatureAccess (the same mechanism as Conjoint, FdChat, …); add
// domains to FEATURE_ACCESS_CONFIG.MultiLanguage to grant specific clients access.
// A function (not a module-level const) so it reads the fd_email cookie at render
// time, after hydration — a top-level const would read the cookie too early.
export const isMultilangPocEnabled = (): boolean =>
  hasFeatureAccess('MultiLanguage')

// The single-market Translations tab additionally needs the researcher's
// per-survey "Needs translation" declaration — useSingleMarketTranslationsEnabled
// in hooks/localState/useNeedsTranslationVar (a hook, so it stays out of this
// deliberately React-free module).

// Multi-market projects feature. Same mechanism and rationale — focaldata staff in
// every environment, plus any domains in FEATURE_ACCESS_CONFIG.MultiMarket.
export const isMultiMarketEnabled = (): boolean =>
  hasFeatureAccess('MultiMarket')

// Every multi-market step except Results, plus the mutating controls on the
// results bar and the project card. Same grant as creation.
export const canAuthorMultiMarket = (): boolean => isMultiMarketEnabled()

// Global custom audience questions (multi-market). Own flag so it can be
// dark-launched / killed independently of the MultiMarket grant. Only meaningful
// inside MultiMarketV2 projects — callers gate on the project type as well.
export const isGlobalAudienceEnabled = (): boolean =>
  hasFeatureAccess('GlobalAudience')

// Screening rules: disqualification conditions on the market's screener, able to span
// questions. Own flag so it can be dark-launched independently of screener display logic.
export const isScreeningRulesEnabled = (): boolean =>
  hasFeatureAccess('ScreeningRules')

// Screener display logic: a condition on one audience question controlling whether it is shown.
export const isScreenerDisplayLogicEnabled = (): boolean =>
  hasFeatureAccess('ScreenerDisplayLogic')

// Multi-wave (tracker) projects: creating one is limited to staff while the
// tracker flow is being finished.
export const isTrackerEnabled = (): boolean => hasFeatureAccess('Tracker')
